/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Genre_ScifiInputs */

const en_onboarding_genre_scifi = /** @type {(inputs: Onboarding_Genre_ScifiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Science Fiction`)
};

const es_onboarding_genre_scifi = /** @type {(inputs: Onboarding_Genre_ScifiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciencia ficción`)
};

/**
* | output |
* | --- |
* | "Science Fiction" |
*
* @param {Onboarding_Genre_ScifiInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_genre_scifi = /** @type {((inputs?: Onboarding_Genre_ScifiInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Genre_ScifiInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_genre_scifi(inputs)
	return en_onboarding_genre_scifi(inputs)
});